export class TituloReceberResourceOptions  {
    canImportErp_v1: boolean;
    canImportErp: boolean;
    printListagem: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return   this.canImportErp_v1 ||
                this.canImportErp ||
                this.printListagem;
    }
}
